export const PersonStatus = {
  PENDING: 'PENDING',
  ACTIVE: 'ACTIVE',
  DELETED: 'DELETED',
};

export const UserRoles = {
  DEALERSHIP_EMPLOYEE: 'Dealership Employee',
  DEALERSHIP_MANAGER: 'Dealership Manager',
  DEALERSHIP_BILLING: 'Dealership Billing',
  DEALERSHIP_ADMIN: 'Dealership Admin',
};

export const UserRolesId = {
  DEALERSHIP_EMPLOYEE: '760fe34f-3735-4853-bc65-7c75d541035a',
  DEALERSHIP_MANAGER: 'fca94499-da63-41c9-a26a-796def46aef3',
  DEALERSHIP_ADMIN: 'c02e5feb-1fbf-456d-b024-bedef983a252',
};

export const ROLES = [
  {
    roleId: UserRolesId.DEALERSHIP_EMPLOYEE,
    name: UserRoles.DEALERSHIP_EMPLOYEE,
  },
  {
    roleId: UserRolesId.DEALERSHIP_MANAGER,
    name: UserRoles.DEALERSHIP_MANAGER,
  },
  {
    roleId: UserRolesId.DEALERSHIP_ADMIN,
    name: UserRoles.DEALERSHIP_ADMIN,
  },
];

export const Order = {
  ASC: 'asc',
  DESC: 'desc',
};

export const EndPoints = {
  USERS: {
    GET_USERS: '/users/search',
    INVITE_USER: '/persons',
    UPDATE_USER: '/users',
    DELETE_USER: '/users/{userId}',
    RESEND_INVITATION: '/users/{userId}/invites',
    GET_DEPARTMENTS: '/companies/{companyId}/departments',
  },
  USER: {
    GET_PERSON: {
      ENDPOINT: '/users/{personId}',
      METHOD: 'get',
    },
    GET_NOTIFICATIONS: {
      ENDPOINT:
        '/users/{personId}/notifications?pageNumber={pageNumber}&pageSize=10',
      METHOD: 'get',
    },
    UPDATE_NOTIFICATIONS_PREFERENCE: {
      ENDPOINT: '/users/{personId}/preferences/notifications',
      METHOD: 'patch',
    },
    MARK_NOTIFICATION_AS_READ: {
      ENDPOINT: '/notifications/{notificationId}',
      METHOD: 'patch',
    },
    MARK_ALL_NOTIFICATIONS_AS_READ: {
      ENDPOINT: '/users/{personId}/notifications/acknowledgements',
      METHOD: 'patch',
    },
    SAVE_PROFILE: {
      ENDPOINT: '/users/{personId}',
      METHOD: 'patch',
    },
    SEND_VERIFICATION_CODE: {
      ENDPOINT: '/users/{personId}/phones/verification',
      METHOD: 'put',
    },
    VERIFY_VERIFICATION_CODE: {
      ENDPOINT: '/users/{personId}/phones/verification',
      METHOD: 'post',
    },
    ALTERNATIVE_OWNER: {
      ENDPOINT: '/users/search',
      METHOD: 'post',
    },
  },
  ORDERS: {
    BY_VEHICLE: '/orders/vehicles/search',
    PATCH: 'v2/orders/{orderId}',
    GET_DATA: {
      ENDPOINT: '/orders/vendors/{vendorOrderId}',
      METHOD: 'get',
    },
    EDIT_VENDOR_ORDER: {
      ENDPOINT: '/orders/vendors/{vendorOrderId}',
      METHOD: 'patch',
    },
    ADD_SURVEY: {
      ENDPOINT: '/orders/vendors/{vendorOrderId}/surveys',
      METHOD: 'post',
    },
    SIGNOFF_WORK_ORDER: {
      ENDPOINT: '/orders/{orderId}/signoff',
      TYPE: 'post',
    },
    EDIT_DATA: {
      ENDPOINT: '/orders/{orderId}',
      METHOD: 'patch',
    },
    EDIT_CUSTODY: {
      ENDPOINT: '/vehicles/custodies/{custodyId}',
      METHOD: 'patch',
    },
    DELETE_SERVICE: {
      ENDPOINT: '/orders/vendors/{vendorOrderId}/services/{serviceId}',
      METHOD: 'del',
    },
    ADD_SERVICE: {
      ENDPOINT: '/orders/vendors/{vendorOrderId}/services/{serviceId}',
      METHOD: 'post',
    },
    CANCEL_ORDER: {
      ENDPOINT: '/orders/vendors/cancellations/{vendor_order_id}',
      TYPE: 'patch',
    },
    NEW_ORDER: {
      GET_VENDORS: {
        ENDPOINT: '/companies/{companyId}/vendors',
        METHOD: 'get',
      },
      GET_SERVICES_BY_DEPARTMENT: {
        ENDPOINT: '/prices/{vendorId}/{departmentId}',
        METHOD: 'get',
      },
      GET_VEHICLE_BY_VIN: {
        ENDPOINT: '/vehicles/{vin}',
        METHOD: 'put',
      },
      EDIT_VEHICLE_DETAIL: {
        ENDPOINT: '/vehicles/{vehicleId}',
        METHOD: 'patch',
      },
      ADD_VEHICLE_DETAIL: {
        ENDPOINT: '/vehicles',
        METHOD: 'post',
      },
      SAVE: {
        ENDPOINT: '/v2/orders',
        METHOD: 'post',
      },
      GET_FRONTLINE_VEHICLE_LIST: {
        ENDPOINT: '/v2/vehicles/dealer/{companyId}?term={searchTerm}&page=1',
        TYPE: 'GET',
      },
    },
    NEW_SERVICE_ORDER: {
      SAVE: {
        ENDPOINT: '/orders/serviceorders',
        METHOD: 'post',
      },
    },
    UNAPPROVED: {
      GET_ORDERS: {
        ENDPOINT: '/orders/search',
        METHOD: 'post',
      },
      BULK_PDF: {
        ENDPOINT: '/exports/bulks/orders/pdf',
        METHOD: 'post',
      },
      BULK_CSV: {
        ENDPOINT: '/exports/bulks/orders/csv',
        METHOD: 'post',
      },
      APPROVE_DECLINE_ORDER: {
        ENDPOINT: '/orders/vendors/',
        METHOD: 'patch',
      },
    },
    EXPORT_WORK_ORDER: {
      ENDPOINT: '/exports/orders/vendors/{vendor_order_id}/pdf',
      TYPE: 'get',
    },
    VEHICLE_EXPORT_WORK_ORDER: {
      ENDPOINT: '/exports/orders/{order_id}/pdf',
      TYPE: 'get',
    },
    RECON_STATUS: {
      ENDPOINT: '/reconditions/status',
      METHOD: 'post',
    },
    GET_VEHICLE_PHOTOCOUNT: {
      ENDPOINT: '/v2/vehicles/photos/{vinOrStockNumber}',
      TYPE: 'post',
    },
    DEALERS: {
      GET: {
        ENDPOINT: '/companies/{companyId}/dealers',
        TYPE: 'get',
      },
    },
  },
  BULK_EXPORT: {
    BULK_SERVICES: {
      ENDPOINT: '/services/{companyId}',
      TYPE: 'get',
    },
    BULK_DEPARTMENTS: {
      ENDPOINT: '/users/companies/departments',
      TYPE: 'get',
    },
    BULK_PDF: ['/exports/emails/bulks/orders/pdf', 'post'],
    BULK_CSV: ['/exports/emails/bulks/orders/csv', 'post'],
  },
  REPORT: {
    DEALERSHIP_MAPPING: {
      ENDPOINT: '/dealership/mapping-config/{dealershipId}',
      METHOD: 'get',
    },
    FRONTLINE_ANALYTICS: {
      ENDPOINT: '/dealership/fl-analytics/{frontlineDealerId}',
      METHOD: 'get',
    },
    DDPRO_ANALYTICS: {
      ENDPOINT: '/orders/summary/dealer/v2/{companyId}',
      METHOD: 'get',
    },
    DOWNLOAD_DEALERSHIP_SUMMARY_REPORT: {
      ENDPOINT: '/dealership/report/download',
      METHOD: 'post',
    },
    DEALERSHIP_SUMMARY_REPORT: {
      ENDPOINT: '/dealership/summary-report/{dealershipId}',
      METHOD: 'get',
    },
  },
};

export const OrderStatus = {
  approved: 'Approved',
  declined: 'Declined',
  generated: 'Generated',
};

export const CompanyStatus = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};

export const StaticBody = {
  orders: {
    unapproved: {
      pageSize: 20,
      orderBy: 'date',
      order: 'desc',
    },
    myOrders: {
      pageSize: 20,
      orderBy: 'date',
      order: 'desc',
    },
  },
  workQueue: {
    allOrders: (sortEnabled = false, sortBy = '', fieldValue = '') => {
      return {
        pageSize: 20,
        orderBy: sortEnabled ? fieldValue : 'date',
        order: sortEnabled ? sortBy : 'desc',
      };
    },
    done: {
      pageSize: 20,
      orderBy: 'completedOn',
      order: 'desc',
    },
  },
};

export const ApiErrorDataTokens = {
  CANT_CANCEL_ALL_SERVICES: 'CAN_NOT_CANCEL_ALL_SERVICES',
};

export const StatusCode = {
  SUCCESS: 200,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
  NOT_IMPLEMENTED: 501,
};

export const ProcessStep = {
  GENERATED: 'Generated',
  APPROVED: 'Approved',
  IN_TRANSIT: 'In Transit',
  ARRIVED: 'Arrived',
  PAUSED: 'Paused',
  IN_PROCESS: 'In Process',
  DONE: 'Done',
  DECLINED: 'Declined',
  CANCELED: 'Canceled',
  TRANSFERRED: 'Transferred',
  MECHANICAL: 'Mechanical',
  WHOLE_SALE: 'Wholesale',
};

export const WOQuality = {
  BELOW: 'below',
  MEETS: 'meets',
  ABOVE: 'above',
};

export const WOErrorTokens = {
  DUPLICATED: 'DUPLICATE_VENDOR_ORDER',
  SERVICE_LIMIT_EXCEEDED: 'SERVICE_LIMIT_EXCEEDED',
  ORDER_HAS_NO_PENDING_APPROVALS: 'ORDER_HAS_NO_PENDING_APPROVALS',
};

export const HEADERS = {
  AUTHORIZATION: 'authorization',
  X_USER_POOL_ID: 'x-user-pool-id',
  X_APP_CLIENT_ID: 'x-app-client-id',
};

export const UserPersonStatus = {
  ACTIVE: 'ACTIVE',
  PENDING: 'PENDING',
};

export const OrderTypes = {
  WORK_ORDER: 'work_order',
  RECONDITIONING: 'reconditioning',
  ESTIMATE: 'estimate',
  SERVICE_ORDER: 'service_order',
};

export const NewOrderTypes = {
  SIMPLE_ORDER: 'work_order',
  SERVICE_ORDER: 'service_order',
};
